import * as t from 'io-ts';

import {EntryPointTypesEnum} from '../../applications/bridge/v2/types/bridgeTypesV2';
import {makeApiType, makeEnumRuntimeType} from './apiTypes';

/*
 * Runtime types.
 */

const RLegacyEntryPointTypesEnum = makeEnumRuntimeType(EntryPointTypesEnum);

const RLegacyEntryPointDirty = t.type({
  id: t.string,
  type: RLegacyEntryPointTypesEnum,
  name: t.string,
});

/*
 * Types.
 */

export interface LegacyEntryPointModel extends Readonly<t.TypeOf<typeof RLegacyEntryPointDirty>> {}
export const RLegacyEntryPoint = t.clean<LegacyEntryPointModel>(RLegacyEntryPointDirty as any);

/*
 * IO methods.
 */

export function parseLegacyEntryPoint(src: any): LegacyEntryPointModel {
  return {
    id: src.id,
    type: src.type && src.type.toUpperCase(),
    name: src.name,
  };
}

/*
 * API type.
 */

export const ApiEntryPoint = makeApiType('entryPoint', RLegacyEntryPoint, parseLegacyEntryPoint);
